// app.js
require('./app.css');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import Swal from 'sweetalert2';
window.Swal = Swal;
import autosize from 'autosize';

// Import TinyMCE core
import tinymce from 'tinymce/tinymce';

// Import TinyMCE skins (registers CSS via tinymce.Resource.add, no runtime fetch)
import 'tinymce/skins/ui/oxide/skin.js';
import 'tinymce/skins/ui/oxide/content.js';
import 'tinymce/skins/ui/oxide/content.inline.js';
import 'tinymce/skins/content/default/content.js';

// Import all TinyMCE plugins to ensure they're bundled
import 'tinymce/models/dom';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/advlist/plugin';
import 'tinymce/plugins/anchor/plugin';
import 'tinymce/plugins/autolink/plugin';
import 'tinymce/plugins/charmap/plugin';
import 'tinymce/plugins/code/plugin';
import 'tinymce/plugins/codesample/plugin';
import 'tinymce/plugins/directionality/plugin';
import 'tinymce/plugins/emoticons/plugin';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/fullscreen/plugin';
import 'tinymce/plugins/help/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/importcss/plugin';
import 'tinymce/plugins/insertdatetime/plugin';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/nonbreaking/plugin';
import 'tinymce/plugins/pagebreak/plugin';
import 'tinymce/plugins/preview/plugin';
import 'tinymce/plugins/save/plugin';
import 'tinymce/plugins/searchreplace/plugin';
import 'tinymce/plugins/table/plugin';
import 'tinymce/plugins/visualblocks/plugin';
import 'tinymce/plugins/visualchars/plugin';
import 'tinymce/plugins/wordcount/plugin';

import './components/confirm-before-delete';
import './components/new-learner-component';
import './components/learner-component';
import './components/learner-comments';
import './components/learner-todos';
import './components/learner-group';
import './components/learner-account-view';

export { autosize };
export { Swal };

// TinyMCE is bundled and available globally via window.tinymce.
// Skins are pre-registered via the .js imports above (tinymce.Resource.add).
// Pages that need TinyMCE should call tinymce.init() in their own pageScripts.
window.tinymce = tinymce;

export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
